import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class DynamoService {
  private handleError: HandleError;

  constructor(private http: HttpClient, private errHandler: HttpErrorHandlerService) {
    this.handleError = this.errHandler.createHandleError('DynamoService');
  }
  getLookupName(name: string) {
    return this.http.get('api/home/Lookup/' + name);
  }

  postData(data, es): Observable<Response> {
    console.log('Data: ', data);
    return this.http.post<Response>('api/home/Upload' + es, data)
      .pipe(
        catchError(this.handleError('post_entity_' + es, { ok: false } as Response))
      );
  }
}
